import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Form,
  Alert,
  Button,
  Input,
  FormFeedback,
  InputGroup,
  CardFooter,
  CardHeader,
  CardTitle,
} from "reactstrap";
import { connect } from "react-redux";
import Select from "react-select";
import { setBreadcrumbItems } from "../../store/actions";
import { useParams } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import * as url from "../../helpers/url_helper";
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { MDBDataTable } from "mdbreact";
import { Link } from "react-router-dom";
import moment from "moment";
import { formatDob, formatMobile, getAge } from "helpers/dob_helper";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

const EventUsers = (props) => {
  document.title = "Event Users - VUF";
  const { id } = useParams();

  const [userdataList, setuserdataList] = useState([]);
  const [DateRange, setDateRange] = useState({});
  const [SelectUser, setSelectUser] = useState({});
  const [selectionRange, setselectionRange] = useState({});

  const [countries, setcountries] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [districtList, setdistrictList] = useState([]);
  const [cityList, setcityList] = useState([]);

  const [selectedCity, setselectedCity] = useState({});
  const [selectedCountry, setselectedCountry] = useState({});
  const [selectedDistrict, setselectedDistrict] = useState({});
  const [selectedState, setselectedState] = useState({});

  const [cityCode, setcityCode] = useState({});
  const [districtCode, setdistrictCode] = useState({});
  const [stateCode, setStateCode] = useState({});
  const [countryDataCode, setcountryDataCode] = useState({});

  const [EventStatus, setEventStatus] = useState("");
  const [RegistrationStatus, setRegistrationStatus] = useState("");
  const [totalUsers, settotalUsers] = useState("");

  const breadcrumbItems = [
    { title: "VUF", link: "#" },
    { title: "Event User List", link: "#" },
  ];

  const UserType = [
    {
      options: [
        { label: "VUF Main App", value: "VUFAPP" },
        { label: "VUF GBN App", value: "VUFGBN" },
        { label: "VUF Sangathan", value: "SANGATHAN_BETA" },
      ],
    },
  ];
  const [isLoading, setLoading] = useState(false);
  const [Eventdetails, setEventdetails] = useState({});
  const [eventLocationDetails, setEventLocationDetails] = useState({});
  const [copy, setcopy] = useState([]);

  useEffect(() => {
    props.setBreadcrumbItems("Event User List", breadcrumbItems);
  });

  useEffect(() => {
    setSelectUser({ label: "VUF Main App", value: "VUFAPP" });
    getEvent();
    // getUsers(true, 'VUFAPP', selectionRange.startDate, selectionRange.endDate, "", "", "", "");

    // Perform your componentDidMount logic here
  }, []);

  function getEvent() {
    setLoading(true);
    let urlPath = "event/eventdetails/" + id;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status) {
          var dataRes = responseData.data;
          var location = responseData.location;
          setEventdetails(dataRes);
          setEventLocationDetails(location);

          var current = new Date();
          current.setHours(0, 0, 0, 0);
          var EventStartD = new Date(dataRes.eventStartDate);
          EventStartD.setHours(0, 0, 0, 0);
          var EventEndD = new Date(dataRes.eventEndDate);
          EventEndD.setHours(23, 59, 59, 999);

          // If both start and end dates are in the past
          if (EventStartD < current && EventEndD < current) {
            setEventStatus("Expired");
          }
          // If the current date is between the start and end dates (event is ongoing)
          else if (EventStartD <= current && EventEndD >= current) {
            setEventStatus("Running");
          }
          // If both start and end dates are in the future (event is upcoming)
          else if (EventStartD > current && EventEndD > current) {
            setEventStatus("UpComing");
          }

          var RegStartD = new Date(dataRes.registrationStartDate);
          RegStartD.setHours(0, 0, 0, 0);
          var RegEndD = new Date(dataRes.registrationEndDate);
          RegEndD.setHours(23, 59, 59, 999);

          if (RegStartD != null && RegEndD != null) {
            setselectionRange({ startDate: RegStartD, endDate: RegEndD });
            var dates = [RegStartD, RegEndD];
            setDateRange(dates);
          }

          // If both start and end dates are in the past
          if (RegStartD < current && RegEndD < current) {
            setRegistrationStatus("Close");
          }
          // If current date is between start and end dates
          else if (RegStartD <= current && RegEndD >= current) {
            setRegistrationStatus("Open");
          }
          // If both start and end dates are in the future
          else if (RegStartD > current && RegEndD > current) {
            setRegistrationStatus("UpComing");
          }
          getUsers(
            true,
            dataRes.registrationStartDate,
            dataRes.registrationEndDate,
            "",
            "",
            "",
            ""
          );
        } else {
          alert("Something went wrong, Please try again after sometime.");
          // this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
        // this.setState({ loading: false });
      })
      .finally((final) => {
        setLoading(false);
        // return this.setState({ isInvitingUser: false })
      });
  }

  function getUsers(
    loading,
    startDate,
    endDate,
    Country,
    state,
    district,
    city
  ) {
    // getReportDashboard

    let urlPath = "event/Get-event-users/" + id;
    setLoading(true);
    fetch(url.VUF_APP_API + urlPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        country:
          Country.label == "" || Country.label == "--Select--"
            ? ""
            : Country.label,
        city: city.label == "" || city.label == "--Select--" ? "" : city.label,
        state:
          state.label == "" || state.label == "--Select--" ? "" : state.label,
        district:
          district.label == "" || district.label == "--Select--"
            ? ""
            : district.label,
        startDate: startDate || new Date(),
        endDate: endDate || new Date(),
      }),
    })
      .then((response) => response.json())
      .then((responseData) => {
        if (responseData.status && responseData.data != undefined) {
          var userList = responseData.data.response;
          settotalUsers(responseData.data.response.length);
          setuserdataList(responseData.data.response);
          let datacopy = [];
          userList.forEach((d) =>
            datacopy.push({
              "Sr.no.": userList.indexOf(d) + 1,
              FirstName: d.firstName,
              LastName: d.lastName,
              nickname: d.nickname,
              MobileNo: formatMobile(d.countryCode, d.mobileNo),
              profession: d.profession,
              otherProfession: d.otherProfession,
              Address: d.street_address,
              country: d.country,
              state: d.state,
              district: d.district,
              city: d.city,
              village: d.village,
              area: d.area,
              dob: formatDob(d.dob, "DD-MM-YYYY", ""),
              age: getAge(d.dob),
              remarks: d.remarks,
            })
          );
          setcopy(datacopy);
          if (Country == "" && city == "" && state == "" && district == "") {
            onGetCountryList();
          }
        } else {
          alert("Something went wrong, Please try again after sometime.");
        }
      })
      .catch((error) => {
        console.log("err", error);
        alert("Something went wrong, Please try again after sometime.");
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  function onGetCountryList() {
    let urlPath = "auth/CountryList";

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;

          let countries = [];
          countries.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            countries.push({ label: c.country_name, value: c.id });
          });

          const cot = [{ options: countries }];

          setcountries(cot);

          setselectedCity("");
          setselectedDistrict("");
          setselectedState("");
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetStateList(data) {
    setcountryDataCode(data);
    if (data != null && data != undefined && data != "") {
      let urlPath = "auth/StatesList/" + data;

      fetch(url.VUF_APP_API + urlPath, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        // body: Body,
      })
        .then((response) => response.json())
        .then(async (responseData) => {
          if (responseData.status) {
            var data = responseData.response;

            let stateList = [];
            stateList.push({ label: "--Select--", value: "" });
            data.map((c, i) => {
              stateList.push({ label: c.state_title, value: c.state_id });
            });
            // if (selectedState == "" || selectedState == null) {
            //   var seledlis = userdataList
            //     .map(function (a) {
            //       return a.state;
            //     })
            //     .filter(
            //       (item, i, arr) => arr.findIndex((t) => t === item) === i
            //     );
            //   console.log(seledlis);

            //   stateList = stateList.filter(
            //     (s) =>
            //       seledlis.filter((a) => a != undefined && a == s.label)
            //         .length > 0
            //   );
            //   console.log(stateList);
            // }
            const cot = [{ options: stateList }];
            setStateList(cot);

            setselectedDistrict("");
            setselectedCity("");
          }
        })
        .catch((error) => {
          // // console.log("err", error);
        })
        .finally((final) => {});
    }
  }
  function onGetDistrictList(data) {
    setStateCode(data);

    let urlPath = "auth/DistrictsList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;
          let districtList = [];
          districtList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            districtList.push({ label: c.district_title, value: c.districtid });
          });

          const cot = [{ options: districtList }];
          setdistrictList(cot);
          selectedCity("");
        }
      })
      .catch((error) => {
        // // console.log("err", error);
      })
      .finally((final) => {});
  }
  function onGetCitiesList(data) {
    setdistrictCode(data);
    let urlPath = "auth/CitiesList/" + data;

    fetch(url.VUF_APP_API + urlPath, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      // body: Body,
    })
      .then((response) => response.json())
      .then(async (responseData) => {
        if (responseData.status) {
          var data = responseData.response;
          let cityList = [];
          cityList.push({ label: "--Select--", value: "" });
          data.map((c, i) => {
            cityList.push({ label: c.name, value: c.id });
          });
          const cot = [{ options: cityList }];
          setcityList(cot);
        }
      })
      .catch((error) => {
        console.log("err", error);
      })
      .finally((final) => {
        setLoading(false);
      });
  }

  function dateval(val) {
    console.log(val);
    setDateRange(val);
    if (val.length == 2) {
      setselectionRange({ startDate: val[0], endDate: val[1] });
      getUsers(
        true,
        val[0],
        val[1],
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity
      );
    } else if (val.length == 0) {
      getUsers(
        false,
        selectionRange.startDate,
        selectionRange.endDate,
        selectedCountry,
        selectedState,
        selectedDistrict,
        selectedCity
      );
    }
  }
  function exportToExcel(data) {
    var fileName = "EventUser";
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, `${fileName}.xlsx`);
  }

  const formattedEventList = userdataList.map((user) => ({
    ...user,
    firstName:
      user.lastName != null
        ? user.firstName + " " + user.lastName
        : user.firstName,
    mobileNo: formatMobile(user.countryCode, user.mobileNo),
    dob: formatDob(user.dob),
    age: getAge(user.dob, "---"),
    Address:
      user.street_address == undefined ||
      (user.city != null && user.city != undefined && user.city != ""
        ? user.city + ", " + user.state + ", " + user.country
        : "---") ||
      "---",
    Action: [
      <Link
        to={`/UserDetails/EventUsers_${id}/${user._id}`}
        className="btn btn-info btn-sm  "
      >
        {" "}
        <span className="menu-text" style={{ color: "white" }}>
          {" "}
          <span className=" menu-icon fas fa fa-eye" style={{ color: "white" }}>
            {" "}
          </span>
        </span>{" "}
      </Link>,
    ],
  }));

  const tableData = {
    columns: [
      {
        label: "Name",
        field: "firstName",
        sort: "asc",
        width: 23,
      },
      {
        label: "Mobile no.",
        field: "mobileNo",
        sort: "asc",
        width: 10,
      },
      {
        label: "DOB",
        field: "dob",
        sort: "asc",
        width: 10,
      },
      {
        label: "Age(In Years)",
        field: "age",
        sort: "asc",
        width: 5,
      },
      {
        label: "Address",
        field: "Address",
        sort: "asc",
        width: 20,
      },
      {
        label: "Action",
        field: "Action",
        sort: "asc",
        width: 20,
      },
    ],
    rows: formattedEventList,
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <Spinners />
      ) : (
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col md="9">
                    <CardTitle className="h4 mb-0">Event User List</CardTitle>
                  </Col>
                  {userdataList.length > 0 ? (
                    <div className="d-flex justify-content-end">
                      <button
                        className=" btn btn-success float-right "
                        onClick={(event) => exportToExcel(copy)}
                      >
                        Export to Excel
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                </Row>
              </CardHeader>
              <CardBody>
                <div className="event-card">
                  <h2 className="event-title">
                    Event Details: <span>{Eventdetails.eventName}</span>
                  </h2>

                  <div className="event-grid">
                    <div className="event-item">
                      <p className="label">Registration status</p>
                      {RegistrationStatus == "Open" ? (
                        <span className="badge open">Open</span>
                      ) : (
                        ""
                      )}
                      {RegistrationStatus == "Close" ? (
                        <span className="badge closed">Close</span>
                      ) : (
                        ""
                      )}
                      {RegistrationStatus == "UpComing" ? (
                        <span className="badge upcoming">UpComing</span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="event-item">
                      <p className="label">Registration Date</p>
                      <p className="value">
                        {moment(Eventdetails.registrationStartDate).format(
                          "DD MMM YYYY"
                        )}{" "}
                        to{" "}
                        {moment(Eventdetails.registrationEndDate).format(
                          "DD MMM YYYY"
                        )}
                      </p>
                    </div>

                    <div className="event-item">
                      <p className="label">Event status</p>
                      {EventStatus == "Expired" ? (
                        <span className="badge expired">Expired</span>
                      ) : (
                        ""
                      )}
                      {EventStatus == "Running" ? (
                        <span className="badge running">Running</span>
                      ) : (
                        ""
                      )}
                      {EventStatus == "UpComing" ? (
                        <span className="badge upcoming">Upcoming</span>
                      ) : (
                        ""
                      )}
                    </div>

                    <div className="event-item">
                      <p className="label">Event Date</p>
                      <p className="value">
                        {moment(Eventdetails.eventStartDate).format(
                          "DD MMM YYYY"
                        )}{" "}
                        to{" "}
                        {moment(Eventdetails.eventEndDate).format(
                          "DD MMM YYYY"
                        )}
                      </p>
                    </div>

                    <div className="event-item">
                      <p className="label">Event Time</p>
                      <p className="value">
                        {Eventdetails.eventStartTime} -{" "}
                        {Eventdetails.eventEndTime}
                      </p>
                    </div>

                    <div className="event-item">
                      <p className="label">User Count</p>
                      <p className="value">{totalUsers}</p>
                    </div>

                    <div className="event-item">
                      <p className="label">Location Name</p>
                      <p className="value">{eventLocationDetails.name}</p>
                    </div>
                    <div className="event-item">
                      <p className="label">Location</p>
                      <p className="value">
                        {Eventdetails.district}, {Eventdetails.state},{" "}
                        {Eventdetails.country}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="event-card">
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <label>Date Range:</label>
                        <Flatpickr
                          className="form-control d-block"
                          placeholder="Select the date range"
                          value={DateRange}
                          onChange={(e) => {
                            setDateRange(e);
                            dateval(e);
                          }}
                          options={{
                            mode: "range",
                            dateFormat: "d-m-Y",
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country / દેશ:</label>
                        <Select
                          classNamePrefix="select2-selection"
                          value={selectedCountry}
                          onChange={(e) => {
                            setselectedCountry(e);
                            setselectedDistrict({
                              label: "--Select--",
                              value: "",
                            });
                            setselectedCity({ label: "--Select--", value: "" });
                            setselectedState({
                              label: "--Select--",
                              value: "",
                            });
                            getUsers(
                              false,
                              selectionRange.startDate,
                              selectionRange.endDate,
                              e,
                              "",
                              "",
                              ""
                            );
                            onGetStateList(e.value);
                          }}
                          options={countries}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>State / રાજ્ય:</label>
                        <Select
                          classNamePrefix="select2-selection"
                          value={selectedState}
                          onChange={(e) => {
                            setselectedState(e);
                            setselectedDistrict({
                              label: "--Select--",
                              value: "",
                            });
                            setselectedCity({ label: "--Select--", value: "" });
                            getUsers(
                              false,
                              selectionRange.startDate,
                              selectionRange.endDate,
                              selectedCountry,
                              e,
                              "",
                              ""
                            );
                            onGetDistrictList(e.value);
                          }}
                          options={stateList}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>District / જિલ્લો:</label>
                        <Select
                          classNamePrefix="select2-selection"
                          value={selectedDistrict}
                          onChange={(e) => {
                            setselectedDistrict(e);
                            setselectedCity({ label: "--Select--", value: "" });
                            getUsers(
                              false,
                              selectionRange.startDate,
                              selectionRange.endDate,
                              selectedCountry,
                              selectedState,
                              e,
                              ""
                            );
                            onGetCitiesList(e.value);
                          }}
                          options={districtList}
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>City / શહેર:</label>
                        <Select
                          classNamePrefix="select2-selection"
                          value={selectedCity}
                          onChange={(e) => {
                            setselectedCity(e);
                            getUsers(
                              false,
                              selectionRange.startDate,
                              selectionRange.endDate,
                              selectedCountry,
                              selectedState,
                              selectedDistrict,
                              e
                            );
                          }}
                          options={cityList}
                        />
                      </div>
                    </div>
                  </div>
                  <MDBDataTable responsive striped bordered data={tableData} />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      )}
    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(EventUsers);
